<template>
  <div v-if="!showDetails">
    <div v-if="isMobile">
      <app-history v-for="index in history.length" :key="index" :index="index - 1" :item="history[index - 1]"
        @showConfirm="showConfirm" @showReport="showReport" @showCancel="showCancel"  @showHokm="getHokm">
      </app-history>
    </div>
    <div v-else>
      <v-data-table :items="history" item-key="Fserial" :headers="historyHeaders" class="elevation-1 rounded"
        :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText" show-expand>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>توضيحات فرد: </b>
            <span v-html="item.Des_Fard"></span>
            <br />
            <br />
            <b>توضيحات ستاد: </b>
            <span v-html="item.Des_Setad"></span>
            <br />
            <div :key="eIndex" v-for="eIndex in item.enserafs.length">
              <div class="hr-with-text">
                {{
                  `درخواست انصراف در تاریخ ${item.enserafs[eIndex - 1].EnserafDate
                  }`
                }}
              </div>
              <b>توضيحات فرد: </b>
              <span v-html="item.enserafs[eIndex - 1].Des_Fard"></span>
              <br />
              <br />
              <b>توضيحات ستاد: </b>
              <span v-html="item.enserafs[eIndex - 1].Des_Setad"></span>
              <br />
              <br />
            </div>
            <v-btn class="valueButton" v-if="item.IsRemovable" color="red white--text" rounded
              @click="showCancel(item)">
              درخواست انصراف از اعزام
            </v-btn>
            <br />
          </td>
        </template>

        <template v-slot:[`item.Actions`]="{ item }">
          <div>
            <v-btn class="grid" v-if="item.FardState == 0" color="green white--text" rounded @click="showConfirm(item)">
              قبول ماموریت
            </v-btn>
            <template v-if="item.FardState == 1">
              <v-btn class="grid" color="blue white--text" rounded @click="showReport(item)">
                گزارش کار
              </v-btn>
              <v-btn class="grid" style="margin-right: 10px;" color="green white--text" rounded
                @click="getHokm(item.Fserial)">
                دریافت حکم
              </v-btn>
            </template>
          </div>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showConfirmDialog" max-width="600" persistent content-class="myDialog">
      <v-row align="center" v-if="selectedItem && selectedItem.Taahod">
        <v-col class="d-flex" cols="12"> <b>تعهدنامه</b></v-col>
        <v-col class="d-flex" cols="12">
          <span v-html="selectedItem.Taahod"></span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12">
          <v-textarea outlined v-model="confirmObject.Description" no-resize
            placeholder="توضیحات خود را در مورد پذیرش یا عدم پذیرش اعلام فرمایید."></v-textarea>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn class="register" color="red white--text" rounded @click="CloseConfirm">
          بستن
        </v-btn>

        <v-btn class="register" color="orange white--text" rounded @click="handleConfirm(2)">
          عدم تایید
        </v-btn>
        <v-btn class="register" color="primary white--text" rounded @click="handleConfirm(1)">
          پذیرش اعزام
        </v-btn>
      </v-row>
    </v-dialog>
    <v-dialog v-model="showCancelDialog" max-width="600" persistent content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12">
          <v-textarea outlined v-model="cancelObject.Description" no-resize
            placeholder="توضیحات خود را در مورد انصراف اعلام فرمایید."></v-textarea>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn class="register" color="red white--text" rounded @click="CloseCancel">
          بستن
        </v-btn>

        <v-btn class="register" color="primary white--text" rounded @click="handleCancel">
          اعلام انصراف
        </v-btn>
      </v-row>
    </v-dialog>
  </div>
  <div v-else>
    <app-report :ezam="selectedItem" />
  </div>
</template>

<script>
import History from "./History";
import Report from "./Report";
import Dialog from "@/components/Dialog";

import { ConfirmEzam, GetEzamHistory, CancelRequest } from "@/api/ezam";
import { getEzamHokm } from "../../api/ezam";
import { saveByteArray } from '../../utils/constants';
export default {
  components: {
    appHistory: History,
    appReport: Report,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedItem: null,
      history: [],
      showDetails: false,
      showConfirmDialog: false,
      showCancelDialog: false,
      confirmObject: {
        Fserial: 0,
        State: 0,
        Description: "",
      },
      cancelObject: {
        Fserial: 0,
        Description: "",
      },
      initConfirm: {
        Fserial: 0,
        State: 0,
        Description: "",
      },
      initCancel: {
        Fserial: 0,
        Description: "",
      },
      historyHeaders: [
        {
          text: "نام طرح",
          value: "TarhName",
        },
        {
          text: "محل اعزام",
          value: "MahaleEzam",
        },
        {
          text: "وضعیت",
          value: "StateString",
        },
        {
          text: "تاریخ شروع",
          value: "D_StartEzam",
        },
        {
          text: "تاریخ پایان",
          value: "D_EndEzam",
        },
        {
          text: "مهلت انجام",
          value: "D_Mohlat",
        },
        {
          text: "",
          value: "Actions",
          width: "25%",
          sortable: false,
        },
        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],

      headerProps: {
        sortByText: "مرتب سازی بر اساس",
      },
    };
  },
  created() {
    if (this.$route.query.showDetails) {
      this.$router.replace({
        query: {}
      })
    }
    this.getEzamHistory();
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    getEzamHistory() {
      GetEzamHistory()
        .then((response) => {
          const data = response.data;
          this.history = data;
          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    showReport(item) {
      this.selectedItem = item;
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showDetails: "true"
        }
      });
    },
    getHokm(Fserial) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      getEzamHokm(Fserial)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    showConfirm(item) {
      this.showConfirmDialog = true;
      this.selectedItem = item;
      this.confirmObject.Fserial = item.Fserial;
      //this.$store.dispatch("getEmtiazDetails", formSerial);
    },
    CloseConfirm() {
      this.showConfirmDialog = false;
      this.selectedItem = null;
      this.confirmObject = { ...this.initConfirm };
      //this.$store.dispatch("getEmtiazDetails", formSerial);
    },
    handleConfirm(newState) {
      this.confirmObject.state = newState;
      ConfirmEzam(this.confirmObject)
        .then((response) => {
          this.$store.commit("SET_SNACKBAR_TEXT", response.data.Message);
          this.CloseConfirm();
          this.getEzamHistory();
        })
        .catch((error) => {
          this.$store.commit("SET_SNACKBAR_TEXT", response.data.Message);
        });
    },
    showCancel(item) {
      this.showCancelDialog = true;
      this.selectedItem = item;
      this.cancelObject.Fserial = item.Fserial;
      //this.$store.dispatch("getEmtiazDetails", formSerial);
    },
    CloseCancel() {
      this.showCancelDialog = false;
      this.selectedItem = null;
      this.cancelObject = { ...this.initCancel };
      //this.$store.dispatch("getEmtiazDetails", formSerial);
    },
    handleCancel() {
      CancelRequest(this.cancelObject)
        .then((response) => {
          this.$store.commit("SET_SNACKBAR_TEXT", response.data.Message);
          this.CloseCancel();
          this.getEzamHistory();
        })
        .catch((error) => {
          this.$store.commit("SET_SNACKBAR_TEXT", response.data.Message);
        });
    },
  },
  watch: {

    '$route'(to, from) {
      this.showDetails = !!this.$route.query.showDetails;
      window.scrollTo(0, 0)
    }
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}

.indent {
  margin-right: 30px;
}

.register {
  max-width: 100px !important;
}

.valueButton {
  margin-bottom: 20px;
}
</style>
